import DetailedCourseContainer from "../../../components/miscellaneous/learning/detailedCourse";

const CourseDetails = () => {
  return <DetailedCourseContainer />;
};

export default CourseDetails;
